import { render, staticRenderFns } from "./ItemHistoryChangeTypeCheckbox.vue?vue&type=template&id=255ba329&scoped=true"
import script from "./ItemHistoryChangeTypeCheckbox.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChangeTypeCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ba329",
  null
  
)

export default component.exports